
import PlusCircleIcon from './Icons/PlusCircleIcon.vue'
import MinusCircleIcon from './Icons/MinusCircleIcon.vue'

export default {
    name: "Collapsable",
    components: {
        PlusCircleIcon,
        MinusCircleIcon
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        isCollapsable: {
            type: Boolean,
            default: true
        },
        showBtn: {
            type: Boolean,
            default: true
        }
    },
    model: {
        event: 'change',
        prop: 'isOpen'
    },
    watch: {
        isOpen() {
            if (this.isCollapsable) {
                this.show = this.isCollapsable ? this.isOpen : true
            }
        }
    },
    data() {
        return {
            show: this.isCollapsable ? this.isOpen : true
        }
    },
    methods: {
        toggle() {
            if (!this.showBtn) return
            this.$emit('change', !this.isOpen)
        }
    }
}
